import Vue from 'vue'
export const EventBus = new Vue()

export const BUS_EVENT ={
    ENABLE_INPUT:'onEnableInput',
    ADD_LOG:'onAddLog'
}


// WEBPACK FOOTER //
// ./src/eventBus/index.js